var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    height: 50,
    width: 50,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C0E4E3;}\r\n\t.st1{fill:#FCC172;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.1,161.36c-12.11-15.01-11.21-34.12-11.21-50.69c0-3.55-0.09-23.73-0.09-23.73s77.87,0.45,79.1,0.45 c9.09,0,15.83,5.41,20.42,11.94c3.43,4.89,3.83,5.19,3.9,12.67c0.03,3.28,4.01,4.89,6.3,2.53l49.72-41.31 c2.58-2.66,0.04-7.03-3.55-6.1c-11.23,2.92-25.89,6.72-25.89,6.72c-11.24-13.53-27.97-21.56-45.9-21.54c0,0-72.12,0-72.12,0 c-32.09,0-58.88,15.04-58.88,57.57C54.9,135.64,63.99,150.14,113.1,161.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.24,122.02c-15.49,0-28.03,12.56-28.03,28.04c-0.38,23.69,28.9,36.89,46.38,21.18 C193.05,154.89,180.91,121.69,155.24,122.02z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.3,128.84c11.29,9.93,13.43,14.34,13.43,50.84c0,4.6-0.69,9.06-2.12,13.19 c-5.34,11.46-16.78,19.26-30.15,19.28l-73.66,0v-33.83c0-3.26-3.94-4.9-6.26-2.6l-56.06,45.89c-2.69,2.68-0.03,7.18,3.61,6.12 l25.61-10.99c0,12.1,5.11,30.05,27.15,30.05h100.82c32.09,0,58.73-25.65,58.88-57.58c0-0.6-0.03-1.8-0.03-2.4 C255.53,160.9,245.47,141.89,194.3,128.84z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eda0ed0fd93684a37ca016b7c1b58c28.svg";
export { ForwardRef as ReactComponent };